<template>
    <div>
        <fn-form :uri="formUri" uri-method="POST" no-autoload no-buttons v-model="form" @success="onSuccess" @fail="onFail" @cancel="handleCancel" ref="form">
            <template v-slot="{loading, loaded, submit, flags, cancel}">
                <div class="row margin-vertical-15">
                    <div class="col-8 floating-label check-label">{{ $t('Set as default ACH') }}</div>
                    <div class="col-4 text-right">
                        <fn-type-checkbox-input
                            statement=""
                            :checked-value="true"
                            :unchecked-value="false"
                            v-model="makeDefaultACH"
                            switch>
                        </fn-type-checkbox-input>     
                    </div>
                </div>

                <lease-carousel v-if="makeDefaultACH" v-model="selectedLease" />
                <fn-form-schema>
                    <fn-form-group :schema="inputs.bank"></fn-form-group>
                    <fn-form-group :schema="inputs.routing"></fn-form-group>
                    <fn-form-group :schema="inputs.account"></fn-form-group>
                </fn-form-schema>
                <div class="form-group">
                    <fn-ui-button variant="outline-primary" class="btn-block"
                                :disabled="!flags.valid || loading || submitting" :submitting="submitting"
                                type="submit" @click.prevent="handleSubmit" >{{ $t("Add ACH") }}
                    </fn-ui-button>
                    <fn-ui-button variant="outline-primary" class="btn-block" @click="cancel">{{ $t("Cancel") }}</fn-ui-button>
                </div>
            </template>
        </fn-form>        
    </div>
</template>

<script>

import {PAYMENT_METHODS_SCREEN} from "@/features/profile/screens/index";
import {fnResponseToNotification} from "@fndry-vue/fn-notify";
import LeaseCarousel from "../components/LeaseCarousel.vue";
import {
    FnTypeCheckboxInput
} from "@fndry-vue/fn-types";

export default {
    name: "AddBankScreen",
    components: { LeaseCarousel, FnTypeCheckboxInput },
    data() {
        return {
            formUri: '/api/v1/mobile/banks',
            inputs: {
                bank: {
                    key: "bank",
                    id: "bank",
                    name: "bank",
                    placeholder: this.$t("Bank Name"),
                    type: "text",
                    required: true,
                },
                routing: {
                    key: "routing",
                    id: "routing",
                    name: "routing",
                    placeholder: this.$t("Routing Number"),
                    type: "text",
                    required: true,
                },
                account: {
                    key: "account",
                    id: "account",
                    name: "account",
                    placeholder: this.$t("Checking Account"),
                    type: "text",
                    required: true,
                },
            },
            form: {
                bank: "",
                routing: null,
                account: "",
                loan_number: null
            },
            makeDefaultACH: false,
            selectedLease: null,
            submitting: false
        }
    },
    methods: {
        goToPaymentsTab() {
            this.$router.push({
                name: PAYMENT_METHODS_SCREEN
            })
        },
        handleSubmit() {
            this.form.loan_number = this.selectedLease ? this.selectedLease.loan_number : null;
            this.submitting = true;
            
            this.$fnApi.call(this.formUri, 'POST', this.form).then(response => {
                if(response.status) {
                    this.onSuccess(response);
                } else {
                    this.onFail(response);
                }
            })
            .finally(() => {
                this.submitting = false;
            });
        },
        onSuccess(response) {
            if(response.status) {
                this.goToPaymentsTab();
            } else if(response.error && (response.error?.bank || response.error?.routing || response.error?.account)) {
                this.onFail(response);
            } else {
                this.$fnNotify(fnResponseToNotification(response))
            }
        },
        onFail(response) {
            let error = '';
            if(response.error?.bank) {
                error = response.error.bank[0]
            } else if(response.error?.routing) {
                error = response.error.routing[0];
            } else if(response.error?.bank) {
                error = response.error.bank[0]
            }

            this.$fnNotify({
                message: error,
                type: 'error'
            })
        },
        handleCancel() {
            this.goToPaymentsTab();
        },
        makeDefault(type, id) {
            this.loading = true;
            var data = {
                type: "bank",
                id: id
            };

            if (this.selectedLease) {
                data = { 
                    ...data, 
                    loan_number: this.selectedLease.loan_number,
                    routing_number: this.pendingBank.routing,
                    account: this.pendingBank.account
                };
            }

            this.$fnApi.call('/api/v1/mobile/customers/payments/default', 'POST', data).then(response => {
                if(response.status) {
                    this.refresh();
                } else {
                    this.$fnNotify(fnResponseToNotification(response))
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },
    }
}
</script>

<style scoped>
.check-label {
    color: grey;
}
.margin-vertical-15{
    margin-top: 15px;
    margin-bottom: 15px;
}
</style>